import styled from "styled-components";
import { colors, types } from "../../../libs/themes";

export const Card = styled.div<{
  width?: string;
  height?: string;
}>`
  width: ${({ width }) => width || "256px"};
  height: ${({ height }) => height || "145px"};
  background-color:  ${colors.background.shadowSmoke};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.01);
  }
`;

export const Text = styled.div`
${types.headers.small}
  color: ${colors.background.black};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 10px;
    span {
    margin: 0;
  }
`;


